import createIcon from '@/lib/create-icon'

const RugbyLeagueIcon = createIcon(
  <svg
    id='filled-icon'
    xmlns='http://www.w3.org/2000/svg'
    width='18'
    height='18'
    viewBox='0 0 46 46'
    fill='none'
  >
    <path
      stroke='0'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M23.8008 4.5C20.5381 4.5 17.3412 5.41688 14.5745 7.14607L14.4206 7.24225C11.8934 8.82172 9.79691 11.0026 8.31834 13.5901L7.91286 14.2997C6.83374 16.1882 7.87554 18.5833 9.99274 19.0814L20.7167 21.6047C21.8836 21.8793 22.7083 22.9206 22.7083 24.1194V25.5833H7.66667C5.91776 25.5833 4.5 27.0011 4.5 28.75V38.3333C4.5 40.0822 5.91776 41.5 7.66667 41.5H14.375C17.1824 41.5 19.4583 39.2241 19.4583 36.4167V28.75C19.4583 28.5213 19.4341 28.2983 19.388 28.0833H22.7083V36.8887C22.7083 38.3769 23.9148 39.5833 25.403 39.5833C33.4012 39.5833 40.1203 33.5694 41.0036 25.6201L41.1719 24.1058C41.4002 22.0505 41.2603 19.9709 40.7588 17.9646L40.6891 17.6861C40.5217 17.0163 39.843 16.6091 39.1733 16.7765C38.5036 16.944 38.0964 17.6226 38.2638 18.2924L38.3334 18.5709C38.7629 20.2889 38.8827 22.0697 38.6871 23.8298L38.5189 25.344C37.7763 32.0272 32.1273 37.0833 25.403 37.0833C25.2955 37.0833 25.2083 36.9962 25.2083 36.8887V24.1194C25.2083 21.7605 23.5855 19.7115 21.2893 19.1712L10.5653 16.6479C10.0748 16.5325 9.83345 15.9776 10.0835 15.5401L10.489 14.8305C11.7626 12.6015 13.5686 10.7228 15.7456 9.36224L15.8995 9.26606C18.2688 7.7852 21.0067 7 23.8008 7C26.168 7 28.4286 7.55708 30.4426 8.56037C31.0606 8.86819 31.811 8.6168 32.1189 7.99887C32.4267 7.38094 32.1753 6.63047 31.5574 6.32264C29.2045 5.1506 26.5632 4.5 23.8008 4.5ZM7.66667 28.0833H16.2917C16.6599 28.0833 16.9583 28.3818 16.9583 28.75V32.2917H7V28.75C7 28.3818 7.29848 28.0833 7.66667 28.0833ZM7 34.7917H16.9583V36.4167C16.9583 37.8434 15.8017 39 14.375 39H7.66667C7.29848 39 7 38.7015 7 38.3333V34.7917Z'
      fill='url(#paint0_linear_4792_481)'
    />
    <path
      stroke='0'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M23.8008 4.5C20.5381 4.5 17.3412 5.41688 14.5745 7.14607L14.4206 7.24225C11.8934 8.82172 9.79691 11.0026 8.31834 13.5901L7.91286 14.2997C6.83374 16.1882 7.87554 18.5833 9.99274 19.0814L20.7167 21.6047C21.8836 21.8793 22.7083 22.9206 22.7083 24.1194V25.5833H7.66667C5.91776 25.5833 4.5 27.0011 4.5 28.75V38.3333C4.5 40.0822 5.91776 41.5 7.66667 41.5H14.375C17.1824 41.5 19.4583 39.2241 19.4583 36.4167V28.75C19.4583 28.5213 19.4341 28.2983 19.388 28.0833H22.7083V36.8887C22.7083 38.3769 23.9148 39.5833 25.403 39.5833C33.4012 39.5833 40.1203 33.5694 41.0036 25.6201L41.1719 24.1058C41.4002 22.0505 41.2603 19.9709 40.7588 17.9646L40.6891 17.6861C40.5217 17.0163 39.843 16.6091 39.1733 16.7765C38.5036 16.944 38.0964 17.6226 38.2638 18.2924L38.3334 18.5709C38.7629 20.2889 38.8827 22.0697 38.6871 23.8298L38.5189 25.344C37.7763 32.0272 32.1273 37.0833 25.403 37.0833C25.2955 37.0833 25.2083 36.9962 25.2083 36.8887V24.1194C25.2083 21.7605 23.5855 19.7115 21.2893 19.1712L10.5653 16.6479C10.0748 16.5325 9.83345 15.9776 10.0835 15.5401L10.489 14.8305C11.7626 12.6015 13.5686 10.7228 15.7456 9.36224L15.8995 9.26606C18.2688 7.7852 21.0067 7 23.8008 7C26.168 7 28.4286 7.55708 30.4426 8.56037C31.0606 8.86819 31.811 8.6168 32.1189 7.99887C32.4267 7.38094 32.1753 6.63047 31.5574 6.32264C29.2045 5.1506 26.5632 4.5 23.8008 4.5ZM7.66667 28.0833H16.2917C16.6599 28.0833 16.9583 28.3818 16.9583 28.75V32.2917H7V28.75C7 28.3818 7.29848 28.0833 7.66667 28.0833ZM7 34.7917H16.9583V36.4167C16.9583 37.8434 15.8017 39 14.375 39H7.66667C7.29848 39 7 38.7015 7 38.3333V34.7917Z'
      fill='white'
      fillOpacity='0.04'
    />
    <path
      stroke='0'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M23.8008 4.5C20.5381 4.5 17.3412 5.41688 14.5745 7.14607L14.4206 7.24225C11.8934 8.82172 9.79691 11.0026 8.31834 13.5901L7.91286 14.2997C6.83374 16.1882 7.87554 18.5833 9.99274 19.0814L20.7167 21.6047C21.8836 21.8793 22.7083 22.9206 22.7083 24.1194V25.5833H7.66667C5.91776 25.5833 4.5 27.0011 4.5 28.75V38.3333C4.5 40.0822 5.91776 41.5 7.66667 41.5H14.375C17.1824 41.5 19.4583 39.2241 19.4583 36.4167V28.75C19.4583 28.5213 19.4341 28.2983 19.388 28.0833H22.7083V36.8887C22.7083 38.3769 23.9148 39.5833 25.403 39.5833C33.4012 39.5833 40.1203 33.5694 41.0036 25.6201L41.1719 24.1058C41.4002 22.0505 41.2603 19.9709 40.7588 17.9646L40.6891 17.6861C40.5217 17.0163 39.843 16.6091 39.1733 16.7765C38.5036 16.944 38.0964 17.6226 38.2638 18.2924L38.3334 18.5709C38.7629 20.2889 38.8827 22.0697 38.6871 23.8298L38.5189 25.344C37.7763 32.0272 32.1273 37.0833 25.403 37.0833C25.2955 37.0833 25.2083 36.9962 25.2083 36.8887V24.1194C25.2083 21.7605 23.5855 19.7115 21.2893 19.1712L10.5653 16.6479C10.0748 16.5325 9.83345 15.9776 10.0835 15.5401L10.489 14.8305C11.7626 12.6015 13.5686 10.7228 15.7456 9.36224L15.8995 9.26606C18.2688 7.7852 21.0067 7 23.8008 7C26.168 7 28.4286 7.55708 30.4426 8.56037C31.0606 8.86819 31.811 8.6168 32.1189 7.99887C32.4267 7.38094 32.1753 6.63047 31.5574 6.32264C29.2045 5.1506 26.5632 4.5 23.8008 4.5ZM7.66667 28.0833H16.2917C16.6599 28.0833 16.9583 28.3818 16.9583 28.75V32.2917H7V28.75C7 28.3818 7.29848 28.0833 7.66667 28.0833ZM7 34.7917H16.9583V36.4167C16.9583 37.8434 15.8017 39 14.375 39H7.66667C7.29848 39 7 38.7015 7 38.3333V34.7917Z'
      fill='url(#paint1_radial_4792_481)'
      fillOpacity='0.6'
    />
    <path
      stroke='0'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M31.625 22.7083C29.3468 22.7083 27.5 24.5552 27.5 26.8333C27.5 29.1115 29.3468 30.9583 31.625 30.9583C33.9032 30.9583 35.75 29.1115 35.75 26.8333C35.75 24.5552 33.9032 22.7083 31.625 22.7083ZM30 26.8333C30 25.9359 30.7275 25.2083 31.625 25.2083C32.5225 25.2083 33.25 25.9359 33.25 26.8333C33.25 27.7308 32.5225 28.4583 31.625 28.4583C30.7275 28.4583 30 27.7308 30 26.8333Z'
      fill='url(#paint2_linear_4792_481)'
    />
    <path
      stroke='0'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M31.625 22.7083C29.3468 22.7083 27.5 24.5552 27.5 26.8333C27.5 29.1115 29.3468 30.9583 31.625 30.9583C33.9032 30.9583 35.75 29.1115 35.75 26.8333C35.75 24.5552 33.9032 22.7083 31.625 22.7083ZM30 26.8333C30 25.9359 30.7275 25.2083 31.625 25.2083C32.5225 25.2083 33.25 25.9359 33.25 26.8333C33.25 27.7308 32.5225 28.4583 31.625 28.4583C30.7275 28.4583 30 27.7308 30 26.8333Z'
      fill='white'
      fillOpacity='0.04'
    />
    <path
      stroke='0'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M31.625 22.7083C29.3468 22.7083 27.5 24.5552 27.5 26.8333C27.5 29.1115 29.3468 30.9583 31.625 30.9583C33.9032 30.9583 35.75 29.1115 35.75 26.8333C35.75 24.5552 33.9032 22.7083 31.625 22.7083ZM30 26.8333C30 25.9359 30.7275 25.2083 31.625 25.2083C32.5225 25.2083 33.25 25.9359 33.25 26.8333C33.25 27.7308 32.5225 28.4583 31.625 28.4583C30.7275 28.4583 30 27.7308 30 26.8333Z'
      fill='url(#paint3_radial_4792_481)'
      fillOpacity='0.6'
    />
    <path
      stroke='0'
      d='M34.9916 15.0002H40.1156C40.4516 15.0002 40.6336 14.8182 40.6336 14.4822V13.6982C40.6336 13.3622 40.4516 13.1802 40.1156 13.1802H36.5036V5.7602C36.5036 5.4242 36.2796 5.2002 35.9296 5.2002H34.7536C34.4176 5.2002 34.1936 5.4242 34.1936 5.7602V14.2022C34.1936 14.6922 34.5016 15.0002 34.9916 15.0002Z'
      fill='url(#paint4_linear_4792_481)'
    />
    <path
      stroke='0'
      d='M34.9916 15.0002H40.1156C40.4516 15.0002 40.6336 14.8182 40.6336 14.4822V13.6982C40.6336 13.3622 40.4516 13.1802 40.1156 13.1802H36.5036V5.7602C36.5036 5.4242 36.2796 5.2002 35.9296 5.2002H34.7536C34.4176 5.2002 34.1936 5.4242 34.1936 5.7602V14.2022C34.1936 14.6922 34.5016 15.0002 34.9916 15.0002Z'
      fill='white'
      fillOpacity='0.04'
    />
    <path
      stroke='0'
      d='M34.9916 15.0002H40.1156C40.4516 15.0002 40.6336 14.8182 40.6336 14.4822V13.6982C40.6336 13.3622 40.4516 13.1802 40.1156 13.1802H36.5036V5.7602C36.5036 5.4242 36.2796 5.2002 35.9296 5.2002H34.7536C34.4176 5.2002 34.1936 5.4242 34.1936 5.7602V14.2022C34.1936 14.6922 34.5016 15.0002 34.9916 15.0002Z'
      fill='url(#paint5_radial_4792_481)'
      fillOpacity='0.6'
    />
    <defs>
      <linearGradient
        id='paint0_linear_4792_481'
        x1='4.5'
        y1='4.5'
        x2='46.7073'
        y2='33.635'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint1_radial_4792_481'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(22.8891 41.5) scale(18.3891 18.8418)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='paint2_linear_4792_481'
        x1='4.5'
        y1='4.5'
        x2='46.7073'
        y2='33.635'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint3_radial_4792_481'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(22.8891 41.5) scale(18.3891 18.8418)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='paint4_linear_4792_481'
        x1='4.5'
        y1='4.5'
        x2='46.7073'
        y2='33.635'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint5_radial_4792_481'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(22.8891 41.5) scale(18.3891 18.8418)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
    </defs>
  </svg>,
  'RugbyLeagueIcon'
)

export default RugbyLeagueIcon
